module.exports = __webpack_public_path__ + "img/about2.b83fd2b.jpg";